import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

// Patrón calcado de `assets/product-inventory.js` (Horizon 2026-09).
// Motivo (2026-09-29): el variant-picker de Horizon SOLO morfea su propio
// tag `<variant-picker>` en PDP normal; los demás bloques del section son
// custom elements que se suscriben a `productSelect` en el <section> y se
// morfean a sí mismos leyendo `event.promise.then(({detail}) => detail.html)`.
// Como este block era Liquid puro sin custom element, se quedaba con el
// HTML del render inicial y mostraba "Disponible" al cambiar a variantes
// agotadas — engañando sobre el stock real.
class The90sProductAvailabilityIndicator extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newIndicator = html.querySelector('the90s-product-availability-indicator');
        if (!newIndicator) return;

        morph(this, newIndicator, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError')
          console.warn('[the90s-product-availability-indicator] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('the90s-product-availability-indicator')) {
  customElements.define('the90s-product-availability-indicator', The90sProductAvailabilityIndicator);
}
